import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import Navbar from "./Navbar";
import MainPage from "./Pages/MainPage";
import Footer from "./Footer";
import GoAnyWhere from "./Pages/GoAnyWhere";
import EatAnyTime from "./Pages/EatAnyTime";
import GetAnyThing from "./Pages/GetAnyThing";
import PayAnyOne from "./Pages/PayAnyOne";
import SchoolRides from "./Pages/SchoolRides";
import Packages from "./Pages/Packages";
import { useTranslation } from "react-i18next";
import Delivary from "./Pages/Delivary";
import { useState } from "react";

function App() {
  const t = useTranslation();
  const [theState, setTheState] = useState(false);

  return (
    <div style={{ backgroundColor: "#EBF6FF" }}>
      <Navbar theState={theState} />
      <HashRouter>
        <Routes>
          <Route path="/" element={<MainPage setTheState={setTheState} />} />
          <Route
            path="/GoAnyWhere"
            element={<GoAnyWhere setTheState={setTheState} />}
          />
          <Route
            path="/EatAnyTime"
            element={<EatAnyTime setTheState={setTheState} />}
          />
          <Route
            path="/GetAnyThing"
            element={<GetAnyThing setTheState={setTheState} />}
          />
          <Route
            path="/PayAnyOne"
            element={<PayAnyOne setTheState={setTheState} />}
          />
          <Route
            path="/SchoolRides"
            element={<SchoolRides setTheState={setTheState} />}
          />
          <Route
            path="/Delivary"
            element={<Delivary setTheState={setTheState} />}
          />
          <Route
            path="/Packages"
            element={<Packages setTheState={setTheState} />}
          />
        </Routes>
        <Footer />
      </HashRouter>
    </div>
  );
}

export default App;
